module.exports = __webpack_public_path__ + "static/media/bold.ab92ec0a.svg";